// extracted by mini-css-extract-plugin
module.exports = {"blob1":"BackgroundBlobs_blob1__BE8Uy","blob2":"BackgroundBlobs_blob2__1_QzA","blob3":"BackgroundBlobs_blob3__2K8pX"};